import React, { FC } from 'react';
import {
    Datagrid,
    Edit,
    EditButton,
    NumberField,
    ReferenceManyField,
    SimpleForm,
    BooleanInput,
    TextInput,
    NumberInput,
    useTranslate,
    ReferenceArrayInput,
    SelectArrayInput,
    Toolbar,
    SaveButton,
    DeleteButton
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';

import { FieldProps, Category } from '../types';

const FileTitle: FC<FieldProps<Category>> = ({ record }) => {
    const translate = useTranslate();
    return record ? (
        <span>
            {translate('resources.categories.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

const FileEditToolbar = (props: any) => (
    <Toolbar {...props} >
        <SaveButton />
        <DeleteButton />
    </Toolbar>
);

const CategoryEdit = (props: any) => (
    <Edit title={<FileTitle />} {...props}>
        <SimpleForm toolbar={<FileEditToolbar />}>
            <TextInput fullWidth={true} label="Naam" source="name" />
            <TextInput disabled={true} fullWidth={true} label="Afkorting" source="short" />
            <BooleanInput label="Live" source="live"/>
        </SimpleForm>
    </Edit>
);

export default CategoryEdit;
